import React from 'react';
import * as Opt from '../editor/Helpers';
import TextEditor from '../editor/fields/TextEditor';
import ColorSelector from '../editor/fields/ColorSelector';
import MediaSelector from '../editor/fields/MediaSelector';


class ContentSectionLayout extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {

    return (
            <div className={`${window.location.pathname.includes('editor') && (["dt", "mob"].filter((i) => i === this.props.visibility).length) ? 'opacity-50 flex' : this.props.visibility == "dt" ? 'hidden lg:flex' : this.props.visibility == "mob" ? 'lg:hidden' : 'flex'}`}> 
            <div className='container'>
            
            <div className={`rounded-[40px] lg:p-[60px] p-[30px] w-full flex flex-col lg:flex-row bg-${this.props.backgroundColor}`}>

              {/* Main Header here */}
              <div className='w-full lg:w-1/2 mr-[20px]'>
                <p className={`fs-6 mb-[20px] ${this.props.taglineColor}`}>{this.props.tagline}</p>
                <h4 className={`fs-2 font-medium ${this.props.titleColor}`}>{this.props.title}</h4>
                <div className={`block quill-text my-[30px] ${Opt.CalculateFontSize(this.props.textBodyFontSizes)}`} dangerouslySetInnerHTML={{ __html: this.props.text }}></div>
              </div>

              {/* Section here */}
              <div className='w-full lg:w-1/2'>

                {this.props.section.map((section, index) => (
                  <div key={index} className={`w-full flex flex-row ${index > 0 ? 'mt-[30px]' : ''}`}>
                    <div className='align-middle pr-5 overflow-hidden'>
                      <p className={`n-fs-5 align-center ${section.numberColors} bg-${section.numberBackgroundColor} flex justify-center rounded-[10px] px-[15px] py-[5px] mb-[20px] text-center w-fit`}>{`${section.src}`.includes('svg') ? <img className={`${section.numberColors}-filter`} style={{ width: "20px", height: "20px" }} src={section.src} /> : section.number }</p>
                      {index < this.props.section.length - 1 && (
                        <div className="flex ml-[20px]" style={{ height: '80%', width: '6px' }}>
                          <div
                            className={`
                              inline-block
                              self-stretch
                              w-px
                              min-h-[1em]
                              ${section.lineColor}
                              bg-current
                              ${this.props.lineVisible == "yes" ? "opacity-25" : "opacity-0"}
                            `}
                          ></div>
                        </div>
                      )}
                    </div>
                    <div className='flex-1 md:ms-2 ms-1'>
                      <h4 className={`fs-5 ${section.titleColor} break-words`}>{section.title}</h4>
                      <div className={`quill-text my-2 ${Opt.CalculateFontSize(section.textBodyFontSizes)}`} dangerouslySetInnerHTML={{ __html: section.text }}></div>
                    </div>
                  </div>
                ))}
              </div>

            </div>
            </div>
            </div>
    )
  }
}

ContentSectionLayout.defaultProps = {
  lineVisible: "yes",
  visibility: "",
  backgroundColor: 'neutral-cloud-500',
  tagline: 'Tagline',
  taglineColor: 'neutral-charcoal',
  title: 'Medium length section heading goes here',
  titlColor: 'neutral-charcoal',
  text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat.',
  textBodyFontSizes: '',
  section: [
    {
      number: '1',
      src: 'number',
      numberColors: 'neutral-charcoal',
      numberBackgroundColor: 'primary-core',
      lineColor: 'neutral-charcoal',
      title: 'Få bättre betalt',
      titleColor: 'neutral-charcoal',
      textBodyFontSizes: '',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat.',
    },
    {
      number: '2',
      src: 'number',
      numberColors: 'neutral-charcoal',
      numberBackgroundColor: 'primary-core',
      lineColor: 'neutral-charcoal',
      title: 'Få bättre betalt',
      titleColor: 'neutral-charcoal',
      textBodyFontSizes: '',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat.',
    },
    {
      number: '3',
      src: 'number',
      numberColors: 'neutral-charcoal',
      numberBackgroundColor: 'primary-core',
      lineColor: 'neutral-charcoal',
      title: 'Få bättre betalt',
      titleColor: 'neutral-charcoal',
      textBodyFontSizes: '',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat.',
    },
    {
      number: '4',
      src: 'number',
      numberColors: 'neutral-charcoal',
      numberBackgroundColor: 'primary-core',
      lineColor: 'neutral-charcoal',
      title: 'Få bättre betalt',
      titleColor: 'neutral-charcoal',
      textBodyFontSizes: '',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat.',
    }],
}

ContentSectionLayout.fields = {
  backgroundColor: {
    type: "custom",
    render: (props) => <ColorSelector {...props} />
  },
  visibility: {
    type: "select",
    options: Opt.visibilityOptions
  },
  lineVisible: {
    type: "select",
    options: Opt.yesNo
  },
  tagline: { type: "text" },
  taglineColor: {
    type: "select",
    options: Opt.colorVariables
  },
  title: { type: "text" },
  titleColor: {
    type: "select",
    options: Opt.colorVariables
  },
  textBodyFontSizes: Opt.fontSizeOptions,
  text: { type: "custom",
    render: ({ name, onChange, value }) => <TextEditor name={name} value={value} onChange={onChange} />
  },
  section: {
    type: "array",
    arrayFields: {
      number: { type: "number" },
      numberColors: {
        type: "select",
        options: Opt.colorVariables
      },
      numberBackgroundColor: {
        type: "select",
        options: Opt.colorVariables
      },
      lineColor: { 
        type: "select",
        options: Opt.colorVariables
      },
      title: { type: "text" },
      titleColor: {
        type: "select",
        options: Opt.colorVariables
      },
      src: {
        type: "custom",
        render: ({ name, onChange, value }) => <MediaSelector name={'icon'} type={'icon'} onChange={onChange} value={value} />,
      },
      textBodyFontSizes: Opt.fontSizeOptions,
      text: { type: "custom",
      render: ({ name, onChange, value }) => <TextEditor name={name} value={value} onChange={onChange} />
      },
    },
    defaultItemProps: ContentSectionLayout.defaultProps.section[0],
  },
}

export default ContentSectionLayout;